export default "Once Upon A Time opened in 2024.";